<template>
  <div class="wrapperModal">
    <!-- <p class="textPosition">Title</p>
    <el-input v-model="input" placeholder="Add title"></el-input> -->

    <p class="textPosition">Arabic Title</p>
    <el-input
      v-model="arabicTitle"
      :disabled="disabledbutton"
      placeholder="Add title"
    ></el-input>
    <p class="textPosition" :disabled="disabledbutton">English Title</p>
    <el-input
      v-model="englishTitle"
      :disabled="disabledbutton"
      placeholder="Add title"
    ></el-input>
    <!-- <p class="textPosition" :disabled="disabledbutton">Description</p>
    <el-input
      v-model="modalDescription"
      class="qwe"
      placeholder="Add description"
      size="medium"
      type="textarea"
      :disabled="disabledbutton"
    /> -->
    <p class="textPosition">Change channel</p>
    <el-dropdown
      :class="disabledbutton ? 'el-dropdown-link-disabled' : ''"
      @command="handleCommand"
    >
      <span class="el-dropdown-link">
        <div class="itemChannelCategory">{{ titleChangeStream }}</div>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" :disabled="disabledbutton">
        <el-dropdown-item
          v-for="item in MMChannelsCategoty"
          :key="item.id"
          :disabled="disabledbutton"
          :command="item"
          >{{ item.title }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <p class="textPosition">Category</p>
    <el-cascader
      ref="getTitle"
      v-model="valueCasc"
      class="cascaderStyle"
      :options="getInfoCategory"
      :disabled="checkChallelNull"
      placeholder="Category"
      :props="{ children: 'sub_categories', label: 'title', value: 'id' }"
      @change="handleChange"
    ></el-cascader>
    <div v-if="titleCascade">
      <div v-for="item in titleCascade" :key="item" class="colorCategoryText">
        {{ item }}
      </div>
    </div>
    <p class="textPosition">Delete orgonal files :</p>
    <div class="wrapperRadioBox">
      <el-radio
        v-model="deleteOrigVideo"
        :label="true"
        :disabled="disabledbutton"
        class="textPosition"
        border
        >Delete original video</el-radio
      >
      <el-radio
        v-model="deleteOrigVideo"
        :label="false"
        :disabled="disabledbutton"
        class="textPosition"
        border
        >Save original video</el-radio
      >
    </div>
    <div class="wrapperCheckbox">
      <el-checkbox
        v-model="valueCheckboxSharringMM"
        class="selectCheckbox checkboxChoice"
        :disabled="disabledbutton"
        >Upload to Mangomolo</el-checkbox
      >
      <el-checkbox
        v-if="channelType != 'audio'"
        v-model="valueCheckboxSharringSosials"
        :disabled="disabledbutton"
        class="selectCheckbox checkboxChoice"
        >Sharing to social media</el-checkbox
      >
      <el-checkbox
        v-if="valueCheckboxSharringMM"
        v-model="valueCheckBoxPublish"
        class="selectCheckbox checkboxChoice"
        >Publish</el-checkbox
      >
      <el-checkbox
        v-if="(channelType != 'audio' && userId === '112') || '80'"
        v-model="valueCheckboxIntro"
        class="selectCheckbox checkboxChoice"
        :disabled="disabledbutton"
        >Add intro</el-checkbox
      >
      <el-checkbox
        v-if="(channelType != 'audio' && userId === '112') || '80'"
        v-model="valueCheckboxOutro"
        :disabled="disabledbutton"
        class="selectCheckbox checkboxChoice"
        >Add outro</el-checkbox
      >
    </div>
    <el-dropdown
      v-if="valueCheckboxIntro || valueCheckboxOutro"
      :class="disabledbutton ? 'el-dropdown-link-disabled' : ''"
      @command="handleCommandIntro"
    >
      <span class="el-dropdown-link">
        <div class="itemChannelCategory">{{ introOutroChange }}</div>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" :disabled="disabledbutton">
        <el-dropdown-item
          v-for="(item, index) in introOutroList"
          :key="index"
          :command="item"
        >
          {{ item.title }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-if="valueCheckboxIntro" class="introWrapper">
      <div class="textIntroWrapper">Change intro time</div>
      <el-time-picker
        v-model="introTime"
        :picker-options="{
          selectableRange: `00:00:00 - ${outroTime}`,
        }"
        placeholder="Intro time"
      >
      </el-time-picker>
    </div>
    <div v-if="valueCheckboxOutro" class="introWrapper">
      <div class="textIntroWrapper">Change outro time</div>
      <el-time-picker
        v-model="outroTime"
        :picker-options="{
          selectableRange: `${introTime} - ${endTimeIntroOutro}`,
        }"
        placeholder="Outro time"
      >
      </el-time-picker>
    </div>
    <div
      v-if="
        this.progress != undefined &&
        this.progress != 100 &&
        statusProgressMultieditVideo != 'failed'
      "
      class="progress-bar-container"
    >
      <p class="textProgress">Editing progress</p>
      <el-progress
        :status="'success'"
        :width="32"
        :text-inside="true"
        :percentage="this.progress"
        :stroke-width="32"
        :stroke-linecap="'square'"
        class="videoProgressBar"
      />
    </div>
    <sharing-statuses-scroller
      v-if="showScrollBar"
      class="scrollerStatuses"
      :sharings="videoSharings"
    />

    <div>
      <el-button
        :disabled="disabledSaveBtn"
        class="btnPosition btnColor"
        @click="startEdit"
      >
        Save
      </el-button>
      <el-button class="btnPosition" @click="closeModal"> Cancel </el-button>
      <el-button
        v-if="this.progress === 100"
        class="btnPosition btnColor"
        @click="backToClipper"
      >
        Back to the clipper
      </el-button>
    </div>
    <!-- <div v-if="backToMM">
      <a :href="link" target="_blank">
        <el-button class="btnPosition btnColor" @click="backToMMPage"
          >Back to Mangomolo</el-button
        >
      </a>
    </div> -->
  </div>
</template>

<script>
import youtubeIcon from "@/assets/images/youtube_sharing.png";
import facebookIcon from "@/assets/images/facebook_sharing.png";
import instagramIcon from "@/assets/images/instagram_sharing.png";
import twitterIcon from "@/assets/images/twitter_sharing.png";
import { token } from "@/api/params.js";
import SharingStatusesScroller from "@/components/socials/share/SharingStatusesScroller.vue";
import { getChannelsWhithCategory, getCategoryMM } from "@/api/edit.js";
import { getAPI } from "@/api/params.js";
import {
  getChannelsWhithCategoryRadio,
  getCategoryMMRadio,
} from "../../../api/editAudio.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ModalAddDescriptions",
  components: { SharingStatusesScroller },
  props: {
    channels: {
      type: Array,
    },
    videoId: {
      type: Number,
      default: null,
    },
    stream: {
      type: String,
      default: "",
    },
    newGenerateVideo: {
      type: Array,
    },
    disabledbutton: {
      type: Boolean,
      default: false,
    },
    disabledSaveBtn: {
      type: Boolean,
      default: false,
    },
    allTimeNewVideo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      youtubeIcon,
      facebookIcon,
      instagramIcon,
      twitterIcon,
      input: "",
      modalDescription: "Add description",
      arabicTitle: "",
      englishTitle: "",
      deleteOrigVideo: false,
      show: "",
      seria: "",
      season: "",
      category: 0,
      uploadToMangomolo: true,
      sharingMM: false,
      visible: false,
      snapchatLink: null,
      valueCheckboxSharringMM: false,
      valueCheckboxSharringSosials: false,
      getInfoCategory: null,
      progress: 0,
      showScrollBar: false,
      backToMM: false,
      valueCasc: null,
      titleChangeStream: "Change stream",
      valueChangeStream: "Change stream",
      titleCascade: [],
      MMChannelsCategoty: null,
      valueCheckboxIntro: false,
      valueCheckboxOutro: false,
      introOutroChange: "Add an intro or outro",
      introOutroList: null,
      valueCaskaderIntroOutroList: null,
      valueCheckBoxPublish: false,
      introTime: new Date(2016, 9, 10, 0, 0),
      outroTime: new Date(2016, 9, 10, 0, 0),
    };
  },
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      sharings: (state) => state.socials.sharings,
      features: (state) => state.userData.features,
      currentChannel: (state) => state.userData.currentChannel,
      allChannels: (state) => state.userData.channels,
      userId: (state) => state.userData.user_id,
    }),
    checkChallelNull() {
      return this.disabledbutton === false && this.getInfoCategory != null
        ? false
        : true;
    },
    statusProgressMultieditVideo() {
      return this.newGenerateVideo[0]?.status;
    },
    link() {
      return this.sharings[0].link;
    },
    // @vuese
    // Video sharings data
    videoSharings() {
      return this.sharings.filter(
        (s) => s.videoId == this.newGenerateVideo[0]?.id
      );
    },
    sharingResp() {
      return this.newGenerateVideo[0]?.sharings;
    },
    endTimeIntroOutro() {
      const hours = Math.floor(this.allTimeNewVideo / 3600);
      const minutes = Math.floor((this.allTimeNewVideo % 3600) / 60);
      const remainingSeconds = this.allTimeNewVideo % 60;

      const formattedTime = [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
        String(remainingSeconds).padStart(2, "0"),
      ].join(":");

      return formattedTime;
    },
    getDateTime() {
      const [hours, minutes, seconds] = this.endTimeIntroOutro
        .split(":")
        .map(Number);

      const date = new Date();

      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(seconds);
      return date;
    },
    introTimeSeconds() {
      if (this.introTime) {
        return (
          this.introTime.getHours() * 3600 +
          this.introTime.getMinutes() * 60 +
          this.introTime.getSeconds()
        );
      }
      return null;
    },
    outroTimeSeconds() {
      if (this.outroTime) {
        return (
          this.outroTime.getHours() * 3600 +
          this.outroTime.getMinutes() * 60 +
          this.outroTime.getSeconds()
        );
      }
      return null;
    },
  },
  watch: {
    newGenerateVideo() {
      if (this.newGenerateVideo !== null || this.newGenerateVideo !== []) {
        this.progress = 0;
        this.progress = this.newGenerateVideo[0]?.progress;
      }
    },
    progress() {
      if (this.progress == 100) {
        this.$message.success("Video save in clips");
      }
    },
    getDateTime() {
      this.outroTime = this.getDateTime;
    },
    valueCheckboxIntro() {
      if (!this.valueCheckboxIntro) {
        this.introTime = new Date(2016, 9, 10, 0, 0);
      }
    },
    valueCheckboxOutro() {
      if (!this.valueCheckboxOutro) {
        this.outroTime = this.endTimeIntroOutro;
      }
    },
  },
  async created() {
    //Get channels whith category
    if (this.channelType === "audio") {
      const chaneslList = await getChannelsWhithCategoryRadio();
      this.MMChannelsCategoty = chaneslList;
      // this.MMChannelsCategoty = chaneslList.filter(e => {
      //   return e.isOnlyAudio === true;
      // });
    } else {
      const chaneslList = await getChannelsWhithCategory();
      this.MMChannelsCategoty = chaneslList;
      // this.MMChannelsCategoty = chaneslList.filter(e => {
      //   return e.isOnlyAudio === false;
      // });
    }
    this.getIntroList();
    // this.MMChannelsCategoty = chaneslList;
  },
  methods: {
    async handleCommand(changeStream) {
      let categoryChannelMM = [];
      if (this.channelType === "audio") {
        categoryChannelMM = await getCategoryMMRadio(changeStream.id);
      } else {
        categoryChannelMM = await getCategoryMM(changeStream.id);
      }
      this.titleChangeStream = changeStream.title;
      this.getInfoCategory = categoryChannelMM;
      const displayNameStream = this.channels.filter(
        (e) => e.channel_id == changeStream.id
      )[0]?.display_name;
      this.valueChangeStream = displayNameStream;
      this.$emit("valueChangeStream", this.valueChangeStream);
      this.$emit("targetChannelId", changeStream.id);
    },
    async handleCommandIntro(selectCaskader) {
      this.introOutroChange = selectCaskader.title;
      this.valueCaskaderIntroOutroList = selectCaskader;
    },
    startEdit() {
      if (this.englishTitle != "" || this.arabicTitle != "") {
        if (this.modalDescription != "") {
          this.$emit("changeDisabledSaveBtn", true);
          this.$emit("changeDisabledbutton", true);
          this.backToMM = true;
          if (this.valueCheckboxSharringMM === true) {
            this.$emit(
              "shangeFlagOpenModalMM",
              this.englishTitle,
              this.arabicTitle,
              this.modalDescription,
              this.category
            );
          }
          if (this.valueCheckboxSharringSosials === true) {
            this.$emit("shangeFlagOpenModalSosials");
          }
          if (
            this.valueCheckboxSharringMM ||
            this.valueCheckboxSharringSosials
          ) {
            this.showScrollBar = true;
          }
          this.$emit(
            "startEdit",
            this.deleteOrigVideo,
            this.arabicTitle,
            this.englishTitle,
            this.modalDescription,
            this.season,
            this.show,
            this.category,
            this.valueChangeStream,
            this.valueCheckboxIntro,
            this.valueCheckboxOutro,
            this.introTimeSeconds,
            this.outroTimeSeconds,
            this.valueCaskaderIntroOutroList,
            this.valueCheckBoxPublish
          );
        } else {
          this.$message.error("Please fill in all fields.");
        }
      } else {
        this.$message.error("Please fill in all fields.");
      }
    },
    async getIntroList() {
      const response = await fetch(
        `${getAPI()}/mangomolo/get_intro_outro?token=${token}`
      );
      if (response.ok) {
        this.introOutroList = (await response.json()).data;
      }
    },
    backToMMPage() {
      window.location.href = this.link;
    },
    backToClipper() {
      const defaultChannel = this.allChannels[0].id;
      if (this.currentChannel === null) {
        this.$router.push(`/clipper/channels/${defaultChannel}?token=${token}`);
        location.reload();
      } else {
        this.$router
          .push(`/clipper/channels/${this.currentChannel}?token=${token}`)
          .then(() => {
            location.reload();
          });
      }
    },
    handleChange(idCategories) {
      this.$refs.getTitle.toggleDropDownVisible(false);
      const titleCascad = this.$refs.getTitle.getCheckedNodes();
      this.titleCascade = titleCascad[0].pathLabels;
      if (this.titleCascade[1] != "") {
        this.show = this.titleCascade[1];
      }
      if (this.titleCascade[2] != "") {
        this.season = this.titleCascade[2];
      }
      if (this.season || this.show) {
        this.valueCheckboxSharringMM = true;
      }
      // this.show && this.season
      // this.titleCascade
      const filterArr = idCategories[idCategories.length - 1];
      this.category = Number(filterArr);
    },
    closeModal() {
      this.$refs.getTitle.toggleDropDownVisible(false);
      this.$emit("changeDisabledbutton", false);
      this.$emit("changeDisabledSaveBtn", true);
      this.$emit("closeModal");
    },
    shangeFlagOpenModal() {
      this.$emit(
        "shangeFlagOpenModal",
        this.englishTitle,
        this.modalDescription,
        this.category
      );
      // this.visible = true;
      // this.sharingMM = true;
    },
  },
};
</script>

<style>
.selectCheckbox .el-checkbox__input.is-checked + .el-checkbox__label {
  color: white;
}
.el-cascader {
  display: flex;
}

.textPosition {
  text-align: left;
  color: white;
}
.el-radio__input.is-checked + .el-radio__label {
  color: white;
}
.el-radio.is-bordered.is-checked {
  color: white;
}
.btnPosition {
  margin: 10px 0 0 0;
}
.wrapperRadioBox {
  display: flex;
  flex-wrap: wrap;
}
.wrapperCheckbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 15px 0;
  width: 100%;
  max-width: 430px;
}

.btnColor {
  background-color: #67c23a;
  border-color: #67c23a;
}
.modal-footer {
  padding: 0 !important;
}
.btnColor:hover,
.btnColor:focus {
  background: #65ae41;
  border-color: #65ae41;
  color: #ffffff;
}
.cascaderStyle .el-input--suffix .el-input__inner {
  background: #5d5d5d !important;
}
.el-scrollbar ::-webkit-scrollbar {
  display: none !important;
}
.el-dropdown-menu.el-popper::-webkit-scrollbar {
  display: none !important;
}
.el-cascader-menu__list {
  width: 185px;
  height: auto;
  min-height: 60px;
  max-height: 400px;
}
</style>

<style scoped>
.itemChannelCategory {
  width: 100%;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: white !important;
}
.el-popper ::-webkit-scrollbar {
  display: none !important;
}

.el-dropdown {
  width: 100%;
  background: #5d5d5d;
  text-align: left;
  height: 38px;
  border-radius: 5px;
  /* margin: 13px 0 0 0; */
}

.el-dropdown-link.el-dropdown-selfdefine {
  position: relative;
  top: 11px;
  /* right: -16px; */
  display: flex;
  justify-content: space-between;
  margin: 0 11px 0px;
  height: 27px;
}

.el-dropdown-link-disabled {
  background: #3d3d3d;
}

.el-icon-arrow-down.el-icon--right {
  /* display: none; */
}

.el-dropdown-menu.el-popper {
  height: auto;
  overflow: scroll;
  margin-top: 1px;
}

.el-popper ::-webkit-scrollbar {
  display: none !important;
}

.el-icon--right {
  /* margin-left: 57%; */
}

.colorCategoryText {
  color: white;
  background: #5d5d5d;
  margin: 7px;
  padding: 7px;
  border-radius: 15px;
}

.scrollerStatuses {
  width: auto !important;
  margin-top: 10px;
}

.share-dropdown-btn {
  height: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 10px;
  border: none;
  color: white;
  background-color: var(--grey);
}

.textProgress {
  color: white;
}

.videoProgressBar {
  margin: 0 50px;
}

.mangomolo-upload-button {
  padding-right: 28px;
  background-image: url("../../../assets/logo-small.png");
  background-position: center right 4px;
  background-size: 20px;
  background-repeat: no-repeat;
}
.snapchat-share-button {
  padding-right: 28px;
  background-image: url("../../../assets/images/snapchat_sharing.png");
  background-position: center right 4px;
  background-size: 20px;
  background-repeat: no-repeat;
}
.snapchat-share-button img {
  float: left;
  border-radius: 5px;
}
.snapchat-share-button {
  color: white !important;
  text-decoration: none;
}
.checkboxChoice {
  color: white;
  margin: 10px 0;
}
/* .checkboxChoice.is-checked {
  color: white;
} */
.checkboxChoice__label {
  color: black;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000 !important;
}

img.other-socials-img {
  float: right;
  width: 20px;
  height: 20px;
  padding: 7px 4px 7px 0;
}

.introWrapper {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.textIntroWrapper {
  font-size: 14px;
  color: #ffffff;
}

@media only screen and (max-width: 500px) {
  .wrapperCheckbox {
    flex-direction: column;
  }

  .el-radio.is-bordered + .el-radio.is-bordered {
    margin: 0;
  }
}
</style>
